<script setup>
import LeftMenu from "@/components/app/LeftMenu.vue";
import Snackbar from "@/components/utils/Snackbar.vue";
import AppHeader from "@/components/app/AppHeader.vue";

const authStore = useAuthStore()
</script>

<template>
  <v-app>
    <app-header v-if="authStore.$state.user"></app-header>
    <v-main>
      <left-menu></left-menu>
      <router-view v-if="authStore.$state.isInitDone"/>

      <snackbar></snackbar>
    </v-main>
  </v-app>
</template>

<style lang="scss">
@use "/src/scss/settings.scss";
</style>